<template>
    <div>
        <v-card flex class="microCard mx-auto" max-width="1260px">
            <v-container class="microContainer pl-12">
                <v-row>
                    <v-col>
                        <MicroTable
                            :micro-data="microData"
                            :is-microbial="isMicrobial"
                        ></MicroTable>
                    </v-col>
                    <v-col class="actionButtons">
                        <div class="buttonWrapper">
                            <v-icon id="qr-download" @click="downloadQRCodes($event)" size="large">
                                $download-circle
                            </v-icon>
                            <v-tooltip location="bottom" activator="#qr-download">
                                <span>Download QR codes</span>
                            </v-tooltip>
                        </div>
                        <div class="buttonWrapper">
                            <v-icon id="plate-upload" @click="uploadPlates" size="large">
                                $upload-circle
                            </v-icon>
                            <v-tooltip location="bottom" activator="#plate-upload">
                                <span>Upload plates</span>
                            </v-tooltip>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
            <PlateReaderUploadDialog
                :dialog="showUploadDialog"
                :code="$route.params.code"
                codeType="experiment"
                :plates="experimentPlates"
                v-if="showUploadDialog"
                @cancel="cancelUploadDialog"
            />
        </v-card>
        <v-card flex v-if="uploadHistory.length" class="uploadHistory mx-auto">
            <v-card-title> Upload History </v-card-title>
            <v-data-table
                :headers="[
                    { title: 'Upload Date', value: 'date' },
                    { title: 'Number of Files', value: 'count' },
                    { title: 'Uploaded By', value: 'submitters' },
                    { title: 'File Names', value: 'filenames' },
                ]"
                :items="uploadHistory"
                item-key="id"
                class="elevation-1"
                :sort-by="['date']"
            >
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import { defineComponent } from "vue";

import _ from "lodash";
import axios from "../../lib/apiAxios";
import PlateReaderUploadDialog from "./PlateReaderUploadDialog.vue";
import MicroTable from "./MicroTable.vue";
import { EventBus } from "@/lib/event-bus";
import { fetchPlateUploadHistory } from "@/services/api.services";

export default defineComponent({
    name: "MicroForm",
    props: {
        microData: Array,
        isMicrobial: Boolean,
    },

    components: {
        PlateReaderUploadDialog,
        MicroTable,
    },

    async mounted() {
        this.setExperimentPlates();
        await this.getUploadHistory();
    },

    created() {
        EventBus.$on("uploadComplete", async () => {
            await this.getUploadHistory();
        });
    },

    data() {
        return {
            showUploadDialog: false,
            uploadHistory: {},
            experimentPlates: [],
        };
    },
    methods: {
        async downloadQRCodes(event) {
            // Extract qrCode/strain data from plates
            let qrData = this.mapPlatesToStrains();

            // Sort data by qrCode
            qrData = _(qrData)
                .sortBy((plate) => _.toNumber(_.last(_.split(plate.qr_code, "_"))))
                .value();

            const response = await axios.post(`/experiment/excel/qr_code_excel`, qrData, {
                responseType: "blob",
            });
            const fileURL = window.URL.createObjectURL(response.data);
            const fileLink = document.createElement("a");
            const fileName = `${this.$route.params.code}qrCodeExcel.xlsx`;
            fileLink.href = fileURL;
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            event.target.blur();
        },
        async getUploadHistory() {
            this.uploadHistory = await fetchPlateUploadHistory(this.$route.params.code);
        },
        uploadPlates() {
            this.setExperimentPlates();
            this.showUploadDialog = true;
        },
        cancelUploadDialog() {
            this.showUploadDialog = false;
        },
        /**
         *  Create an array of plates for the upload dialog. A plate is an object like:
         *  {
         *     name: string;
         *     plateGroup: string; // contains the "strain" name
         *  }
         */
        setExperimentPlates() {
            this.experimentPlates = this.microData.map((plate) => {
                const strain = _.find(plate, (well) => well.strain_name);
                const plateNumber = plate[0].qr_code.split("_").pop();
                return {
                    name: plateNumber,
                    plateGroup: _.get(strain, "strain_name"),
                };
            });
        },
        mapPlatesToStrains() {
            return this.microData.map((plate) => {
                return {
                    qr_code: plate[0].qr_code,
                    strain: _(plate).map("strain_name").compact().uniq().join(","),
                };
            });
        },
    },
});
</script>

<style>
:root {
    --cellWidth: 90px;
    --cellHeight: 65px;
}
.microCard {
    margin-bottom: 20px;
}
.microContainer {
    color: rgba(0, 0, 0, 1);
    white-space: nowrap;
    min-width: 1260px;
    max-width: 1260px;
}
.uploadHistory {
    max-width: 1260px;
    margin-bottom: 20px;
}
.actionButtons {
    margin-top: 24px;
    float: right;
    display: inline-table;
}
.buttonWrapper {
    margin-bottom: 8px;
}
</style>
